export const REVIEW_OVERLAY_REMOVE_ICON = 'review-overlay-remove-icon';
export const REVIEW_DETAILS = 'review-details';
export const PRODUCT_RATING = 'product-rating';
export const REVIEWS_WRAPPER = 'reviews-wrapper';
export const SOCIAL_PROOF_REVIEW_RESPONSIVE_WRAPPER = 'social-proof-review-responsive-wrapper';
export const SOCIAL_PROOF_REVIEW = 'social-proof-review';
export const REVIEWS = 'reviews';
export const SPINNER_CONTAINER = 'spinner-container';
export const RATING_CLICKABLE = 'rating-clickable';
